export const SET_GALLERY_PAGE = "setGalleryPage";
